<template>
  <div class="zw">

    <v-container fluid
                 class="pa-0">
      <v-row class="flex-nowrap"
             no-gutters>

        <v-col cols="6">

          <v-checkbox v-model="zwselected"
                      color="primary"
                      hide-details
                      class="pa-0 fill-parent"
                      @change="onZweitWohnungSelected($event)">

            <template v-slot:label>
              <v-row no-gutters
                     align="center"
                     class="mylabel enabled--text flex-nowrap">
                <span class="mr-1">Rechtsschutz für weitere Zweit-/Ferienwohnung
                </span>
                <site-tooltip>Im Leistungsumfang
                  <b>EXPERT</b> sind 2 selbstgenutzte Wohneinheiten<br> innerhalb Deutschlands sowie 1 selbstgenutzte Zweitwohnung innerhalb Europas<br> bereits eingeschlossen
                  <b>(EXPERT-Klausel 3)</b>.
                </site-tooltip>
              </v-row>
            </template>
          </v-checkbox>

        </v-col>

        <v-col cols="6">
          <v-row no-gutters
                 class="pa-0">

            <v-col cols="6"
                    class="zusatz--column">
              <div :class="zwselected ? 'selected--text' : 'enabled--text'">
                {{ getSb(statePath) === 0 && tarifIsCharta(statePath) ? 50 : getSb(statePath) }}&nbsp;€
              </div>
            </v-col>

            <v-col cols="6"
                    class="zusatz--column">
              <div :class="zwselected ? 'selected--text' : 'enabled--text'">
                {{ $helpers.toGermanFloatString(zweitwohnungPraemie) }}&nbsp;€
              </div>
            </v-col>

          </v-row>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  computed: {
    ...mapTwoWay(["productLine", "family", "civilServant", "contractlength", "zahlweise", "sb", "zwselected"]),
    ...mapGetters(["getSb", "tarifIsCharta"]),
    zweitwohnungPraemie() {
      return this.$store.getters.singlePraemie(
        "zus. HWRS",
        this.productLine,
        this.family,
        this.beamterBoolToKey(this.civilServant),
        this.sb,
        this.contractlength,
        this.zahlweise,
        this.$store.getters.rabatt(this.statePath)
      );
    }
  },
  methods: {
    onZweitWohnungSelected(event) {
      if (event === true && this.zweitwohnung === null) {
        this.zweitwohnung = {};
      }
    }
  }
};
</script>

<style>
.zw .v-input--checkbox {
  max-width: unset !important;
  width: calc(100% + 32px) !important;
}

.zw .v-icon {
  cursor: pointer;
}

.zw .selected--text {
  color: #0085CF;
  font-size: 16px;
}

.zw .enabled--text {
  font-size: 16px;
}

.zw .mylabel {
  font-size: 16px;
}

.zw .mylabel > span:first-child {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 24px);
}

.zw .v-input--checkbox > label, .zw .v-checkbox > label > .mylabel {
  min-width: calc(100% - 32px) !important;
  width: calc(100% - 32px) !important;
  display: flex;
}

.zw .v-input--checkbox > label > .mylabel {
  min-width: 100% !important;
  width: 100% !important;
  display: flex;
}
</style>

